import { app, db, storage } from "../../firebase/index"
import { collection, doc } from "firebase/firestore"
import { ref, uploadBytesResumable, uploadTask, getDownloadURL } from "firebase/storage";

// get collection reference from firebase
const getCollectionRef = (collectionName) => {
	return collection(db, collectionName)
}

// get document reference from firebase
const getDocumentRef = (collectionName, idDoc) => {
	return doc(db, collectionName, idDoc)
}

// upload file like images and documents from firebase
const uploadFile = async (file, onSetDocumentUrl, onSetProgress, onSetError) => {

	if (!file) return;

	console.log("chargement du fichier...")

	const fileName = `${Date.now()}-${file.name}`

	const storageRef =  ref(storage, `documents/${file.name}`)

	const uploadTask = uploadBytesResumable(storageRef, file)

	onSetError(true)

	uploadTask.on(
		"state_change",
		(snapshot) => {
			const progress = Math.floor(snapshot.bytesTransferred / snapshot.totalBytes) * 100
			onSetProgress(progress)
		},
		(error) => {
			console.log(error)
			onSetError(false)
		},
		() => {
			getDownloadURL(uploadTask.snapshot.ref)
			.then(downloadURL => {
				onSetDocumentUrl(downloadURL)
				onSetError(false)

				console.log(downloadURL)
				return { data: downloadURL }
			})

			// try{
			// 	const result = await getDownloadURL(uploadTask.snapshot.ref)
			// 	console.log(result)
			// 	return {result}
			// }catch(err){
			// 	console.log(err)
			// }
		}
	)
}

export {
	getCollectionRef,
	getDocumentRef,
	uploadFile
}